module.exports = __webpack_public_path__ + "img/repeat-03.66a0eb2f.svg";